export default __webpack_public_path__ + "static/media/programme-my-hearing-loss.ed9af3f0.svg";